// extracted by mini-css-extract-plugin
module.exports = {"page":"AgentApplication_page__3Stc0","iframeContainer":"AgentApplication_iframeContainer__PaCSB"};